import { Grid } from '@mui/joy'
import { Region } from '~/shared/api/regions'
import { PHONE_MASK } from '~/shared/config/masks'
import {
  ArrayInput,
  AsyncAutocompleteInput,
  phoneTransformer,
  phoneValidator,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type DriverFiltersProps = {
  disabled?: boolean
  skeletonShow?: boolean
  isPromotion?: boolean
}

export function DriverFilters({
  disabled,
  skeletonShow,
  isPromotion,
}: DriverFiltersProps) {
  return (
    <Container>
      <ContainerTitle>Фильтры по водителям</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid container xs={12}>
          <Grid xs={6}>
            <ArrayInput
              name='driverPhones'
              label='Телефоны водителей'
              placeholder='Введите телефон (+79991234567) и нажмите Enter'
              readOnly={disabled || isPromotion}
              skeletonShow={skeletonShow}
              autocompleteXs={12}
              validate={phoneValidator}
              transformValue={phoneTransformer}
              noOptionsText='Введите телефон и нажмите Enter'
              mask={PHONE_MASK}
              definitions={{ '0': /[0-9]/ }}
            />
          </Grid>
          <Grid xs={6}>
            <AsyncAutocompleteInput
              name='regionsIds'
              label='Регионы водителей'
              fetchOptions={Region.fetchOptions}
              readOnly={disabled || isPromotion}
              multiple
              autocompleteXs={12}
              skeletonShow={skeletonShow}
              placeholder='Выберите регион водителей'
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
